__turbopack_context__.v({
  "fade-in": "RetailersPage-module-scss-module__Vt3gqa__fade-in",
  "infoSection": "RetailersPage-module-scss-module__Vt3gqa__infoSection",
  "listSection": "RetailersPage-module-scss-module__Vt3gqa__listSection",
  "no-transform": "RetailersPage-module-scss-module__Vt3gqa__no-transform",
  "rotate": "RetailersPage-module-scss-module__Vt3gqa__rotate",
  "searchBar": "RetailersPage-module-scss-module__Vt3gqa__searchBar",
  "searchBarActions": "RetailersPage-module-scss-module__Vt3gqa__searchBarActions",
  "sortBy": "RetailersPage-module-scss-module__Vt3gqa__sortBy",
  "totalHits": "RetailersPage-module-scss-module__Vt3gqa__totalHits",
});
